import { type MouseEvent, useCallback } from "react";
import { useNavigate } from "react-router";
import { useQueryClusterRuns } from "src/queries/compute/compute.query";
import type { ClusterRunResponse } from "src/queries/compute/compute.types";
import { useGetClusterRunUrl } from "../cluster.hooks";

export const useClusterRunTimeSelector = () => {
  const navigate = useNavigate();
  const getClusterRunUrl = useGetClusterRunUrl();

  const { data: clusterRuns } = useQueryClusterRuns<ClusterRunResponse[]>();

  const onClickRenderOption = useCallback(
    (
      _e: MouseEvent<HTMLElement>,
      option: ClusterRunResponse,
      opts?: { viewTransition?: boolean }
    ) => {
      const url = getClusterRunUrl({
        run_time: option.run_time as string,
        task_id: option.task_id,
      });

      if (!url) {
        console.error("app_name & cluster_name are required");
        return;
      }

      void navigate(url, { viewTransition: opts?.viewTransition });
    },
    [getClusterRunUrl, navigate]
  );

  return {
    onClickRenderOption,
    clusterRuns,
  };
};
